import ThirdParty, { Google } from "supertokens-auth-react/recipe/thirdparty";
import { ThirdPartyPreBuiltUI } from "supertokens-auth-react/recipe/thirdparty/prebuiltui";
import EmailPassword from "supertokens-auth-react/recipe/emailpassword";
import { EmailPasswordPreBuiltUI } from "supertokens-auth-react/recipe/emailpassword/prebuiltui";
import Session from "supertokens-auth-react/recipe/session";
import { AppContextProvider } from "./utils/AppContext";
import EmailVerification from "supertokens-auth-react/recipe/emailverification";
import authEventTarget from "./events/AuthEvents";
import translations from "./translations";

export const debounce_ms = 500;
export const min_search_len = 3;
export const min_learnt_signs = 3;

export const teacher_permission = "teacher";
export const admin_permission = "admin";

// Not using env variables for the moment so make sure to update this before deployment
export function getApiDomain() {
    // const apiPort = process.env.REACT_APP_API_PORT || 8000;

    // const apiUrl = process.env.REACT_APP_API_URL || `http://localhost:${apiPort}`;
    const apiUrl = "https://alse-back.nairoeducacion.org";

    return apiUrl;
}

// Not using env variables for the moment so make sure to update this before deployment
export function getWebsiteDomain() {
    // const websitePort = process.env.REACT_APP_WEBSITE_PORT || 3000;

    // const websiteUrl = process.env.REACT_APP_WEBSITE_URL || `http://localhost:${websitePort}`;
    const websiteUrl = "https://alse.nairoeducacion.org";

    return websiteUrl;
}

export const SuperTokensConfig = {
    appInfo: {
        appName: "ALSE",
        apiDomain: getApiDomain(),
        websiteDomain: getWebsiteDomain(),
    },
    getRedirectionURL: async (context: any) => {
        if (context.action === "SUCCESS" && context.newSessionCreated) {
            // called on a successful sign in / up. Where should the user go next?
            authEventTarget.dispatchEvent(new Event("loggedInEvent"))
            let redirectToPath = context.redirectToPath;
            if (redirectToPath !== undefined) {
                // we are navigating back to where the user was before they authenticated
                return redirectToPath;
            }
            if (context.createdNewUser) {
                // user signed up
                return default_route;
            } else {
                // user signed in
                return default_route;
            }
        } else if (context.action === "TO_AUTH") {
            // called when the user is not authenticated and needs to be redirected to the auth page.
            return auth_route;
        }
        // return undefined to let the default behaviour play out
        return undefined;
    },
    // recipeList contains all the modules that you want to
    // use from SuperTokens. See the full list here: https://supertokens.com/docs/guides
    recipeList: [
        EmailVerification.init({
            mode: "REQUIRED", // or "OPTIONAL"
        }),
        EmailPassword.init(),
        ThirdParty.init({
            signInAndUpFeature: {
                providers: [Google.init()],
                // providers: [Google.init(), Apple.init()],
            },
        }),
        Session.init({
            // tokenTransferMethod: "header" // or "cookie"
        }),
    ],
    languageTranslations: {
        translations: translations
    }
};

export const PreBuiltUIList = [ThirdPartyPreBuiltUI, EmailPasswordPreBuiltUI];

export const ComponentWrapper = (props: { children: JSX.Element }): JSX.Element => {
    return <AppContextProvider>
        {props.children}
    </AppContextProvider>
};

export const navItems = [
    {
        name: 'Info',
        icon: 'ℹ️',
        route: '/info'
    },
    {
        name: 'Categorias',
        icon: '📖',
        route: '/categorias'
    },
    {
        name: 'Buscar',
        icon: '🔍',
        route: '/buscar'
    },
    {
        name: 'Practicar',
        icon: '✏️',
        route: '/practicar'
    },
    {
        name: 'Logros',
        icon: '🎖️',
        route: '/logros'
    },
];

export const default_route = '/buscar';
export const auth_route = '/auth';

export const month_names = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'];
